// import memberService from "app/services/memberService";
// import React, { Component } from "react";
// import AsyncSelect from "react-select/async";

// const { searchMerchant,searchMerchantForDistributor } = memberService;
// class MemberAutocomplete extends Component {
//   constructor() {
//     super();
//     this.state = {
//       selectedValue: null,
//       inputValue: "",
//     };
//   }
//   // handle input change event
//   handleInputChange = (value) => {
//     this.setState({ inputValue: value });
//   };

//   handleChange = (value) => {
//     //  debugger;
//     this.setState({ selectedValue: value });
//     this.props.setFieldValue("memberId", value.id);
//     this.props.handleChangeOptions(value.id);
//   };
//   refreshFilter = () => {
//     this.props.refreshFilter();
//   };
//   // load options using API call
//   loadOptions = async (value) => {
//     const inputValue = value.trim().toLowerCase();
//     const { data } = await searchMerchantForDistributor(inputValue);
//     const memberData = [];
//     if (data?.data?.length > 0) {
//       data.data.map((item) =>
//         memberData.push({
//           id: item.memId,
//           label: `${item.uniqueIdentity} - ${item.company} - ${item.memberMobileNo}`,
//         })
//       );
//     }

//     return memberData;
//   };

//   render() {
//     return (
//       <AsyncSelect
//         cacheOptions
//         defaultOptions
//         value={this.state.selectedValue}
//         getOptionLabel={(e) => e.label}
//         getOptionValue={(e) => e.id}
//         loadOptions={this.loadOptions}
//         onInputChange={this.handleInputChange}
//         onChange={this.handleChange}
//         name="memberId"
//       />
//     );
//   }
// }
// export default MemberAutocomplete;

import React, { useState } from "react";
import AsyncSelect from "react-select/async";
import { searchMerchantForDistributor } from "app/services/memberService";

const MemberAutocomplete = (props) => {
  console.log(props);
  const [selectedValue, setSelectedValue] = useState(null);
  const [inputValue, setInputValue] = useState("");

  // handle input change event
  const handleInputChange = (value) => {
    setInputValue(value);
  };

  const handleChange = (value) => {
    setSelectedValue(value);
    props.setFieldValue("memberId", value.id);
    props.handleChangeOptions(value.id);
  };

  // const refreshFilter = () => {
  //   props.refreshFilter();
  // };

  // load options using API call
  const loadOptions = async (value) => {
    const inputValue = value.trim().toLowerCase();
    const { data } = await searchMerchantForDistributor(inputValue);
    const memberData = [];
    if (data?.data?.length > 0) {
      data.data.map((item) =>
        memberData.push({
          id: item.memId,
          label: `${item.uniqueIdentity} - ${item.company} - ${item.memberMobileNo}`,
        })
      );
    }

    return memberData;
  };

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions
      value={selectedValue}
      getOptionLabel={(e) => e.label}
      getOptionValue={(e) => e.id}
      loadOptions={loadOptions}
      onInputChange={handleInputChange}
      onChange={handleChange}
      name="memberId"
    />
  );
};

export default MemberAutocomplete;
